import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('pkpMarketAreaSearch', pkpMarketAreaSearch);

    /**
     * This is a directive for the Market Area search an advanced results list.
     *
     * @author sosoehng.prv
     * @ngInject
     */
    function pkpMarketAreaSearch() {
        return {
            restrict: 'E',
            scope: {
                submitSelection: '&',
                markets: '='
            },
            template:
                require('app/_directives/pkp-market-area-search.directive.html'),
            controller: MarketAreaSearchController,
            controllerAs: 'maSearchCtrl'
        };

        function MarketAreaSearchController(
            $scope,
            TransmissionSystemOperator,
            $filter
        ) {
            var vm = this;

            vm.suggestions = [];
            vm.search = '';
            vm.searchText = '';
            vm.cancel = cancel;
            vm.submitMarketAreas = submitMarketAreas;
            vm.selectAll = selectAll;
            vm.deselectAll = deselectAll;
            vm.onToggle = onToggle;
            vm.widthOfScrollbar = widthOfScrollbar;
            vm.getMarketAreas = getMarketAreas;
            vm.placeholderDefaultValue = 'Enter Market area';
            vm.placeholder = vm.placeholderDefaultValue;
            vm.searchFocused = false;

            $scope.$watch(
                function () {
                    return vm.searchText;
                },
                function () {
                    if (vm.searchText !== '') {
                        vm.search = vm.searchText;
                    }
                }
            );

            function getMarketAreas() {
                vm.uiLoadingInProgress = true;
                if ($scope.markets.length > 0) {
                    vm.suggestions = [];
                    angular.forEach($scope.markets, function (marketArea) {
                        vm.suggestions.push({ name: marketArea });
                    });
                    vm.uiLoadingInProgress = false;
                } else {
                    TransmissionSystemOperator.marketAreas(
                        undefined,
                        function (marketAreas) {
                            angular.forEach(marketAreas, function (marketArea) {
                                var suggestions = $filter('filter')(
                                    vm.suggestions,
                                    { name: marketArea },
                                    true
                                );
                                if (suggestions.length === 0) {
                                    vm.suggestions.push({ name: marketArea });
                                }
                            });
                            vm.uiLoadingInProgress = false;
                        },
                        function () {
                            vm.uiLoadingInProgress = false;
                        }
                    );
                }
            }

            function submitMarketAreas() {
                var marketAreas = getSelectedMarketAreas(vm.suggestions);
                $scope.submitSelection()(marketAreas);
                vm.uiShowSuggestions = false;
            }

            /**
             * Close the dialog and deselect all network points as a reset.
             */
            function cancel() {
                vm.uiShowSuggestions = false;
                deselectAll();
            }

            function getSelectedMarketAreas(marketAreas) {
                var selectedMarketAreas = [];
                var tmpMarketAreas;

                for (var i = 0; i < marketAreas.length; i++) {
                    if (marketAreas[i]._checked === true) {
                        tmpMarketAreas = angular.copy(marketAreas[i]);
                        delete tmpMarketAreas._checked;
                        selectedMarketAreas.push(tmpMarketAreas);
                    }
                }

                var result = '';
                angular.forEach(selectedMarketAreas, function (value) {
                    result += result === '' ? value.name : ', ' + value.name;
                });
                vm.searchText = '';
                vm.placeholder = result;

                return selectedMarketAreas;
            }

            function selectAll() {
                var filterSuggestions = $filter('filter')(
                    vm.suggestions,
                    vm.search
                );
                if (filterSuggestions.length === vm.suggestions.length) {
                    angular.forEach(vm.suggestions, function (suggestion) {
                        suggestion._checked = true;
                    });
                } else {
                    angular.forEach(
                        filterSuggestions,
                        function (filterSuggestion) {
                            var suggestions = $filter('filter')(
                                vm.suggestions,
                                { name: filterSuggestion.name },
                                true
                            );
                            if (suggestions.length === 1) {
                                suggestions[0]._checked = true;
                            }
                        }
                    );
                }
            }

            function deselectAll() {
                for (var i = 0; i < vm.suggestions.length; i++) {
                    vm.suggestions[i]._checked = false;
                }
            }

            /**
             * Don't hide the dropdown when it's toggled.
             * Sometimes hiding is forced when closed via cancel button.
             */
            function onToggle() {
                vm.uiShowSuggestions = true;
            }

            /**
             * Get the width of the scrollbar of the browser.
             * This is useful when you need to adjust elements according to scrollbar width.
             *
             * @see http://www.alexandre-gomes.com/?p=115
             * @returns {number} The width in pixels of the scrollbar
             */
            function widthOfScrollbar() {
                var inner = document.createElement('p');
                inner.style.width = '100%';
                inner.style.height = '200px';

                var outer = document.createElement('div');
                outer.style.position = 'absolute';
                outer.style.top = '0px';
                outer.style.left = '0px';
                outer.style.visibility = 'hidden';
                outer.style.width = '200px';
                outer.style.height = '150px';
                outer.style.overflow = 'hidden';
                outer.appendChild(inner);

                document.body.appendChild(outer);
                var w1 = inner.offsetWidth;
                outer.style.overflow = 'scroll';
                var w2 = inner.offsetWidth;
                if (w1 == w2) {
                    w2 = outer.clientWidth;
                }

                document.body.removeChild(outer);

                return w1 - w2;
            }
        }
    }
})();
